import React, { useEffect, useState, useRef } from 'react';
import * as TRANSLATE from '../../../../common/constants/live/translate';
import * as SIZE from '../../../../common/constants/live/size';
import { toLanguageText } from '../../../../common/utils/convertUtil';

export default function TranslateSetting (props) {
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState(props.language);
  const [size, setSize] = useState(props.size);
  const [sync, setSync] = useState(props.sync);

  const ref = useRef(null);

  const handleClickLanguageItem = (lang) => {
    setLanguage(lang);
    setOpen(false);
    props.onChange(lang, size, sync);
  };

  const handleClickTextSize = (value) => {
    const fontSize = size + value;
    setSize(fontSize);
    props.onChange(language, fontSize, sync);
  };

  const handleClickSync = (value) => {
    const secondsSync = sync + value;
    setSync(secondsSync);
    props.onChange(language, size, secondsSync);
  };

  const handleClickOpen = () => {
    setOpen(!open);
  };

  const handleDocumentClick = (event) => {
    if (!ref.current?.contains(event.target)) {
      if (open) {
        setOpen(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick, false);
    document.addEventListener('touchend', handleDocumentClick, false);

    return function cleanup () {
      document.removeEventListener('click', handleDocumentClick, false);
      document.removeEventListener('touchend', handleDocumentClick, false);
    };
  });

  return (
    <div className='module_translate_setting'>
      <div className='module_translate_setting_inner'>
        <div className='translate_language_select_w'>
          <span className='tl_select_text'>언어선택 (language)</span>
          <div className={`tl_select_box_w ${(open ? 'current' : '')}`}>
            <button className='tl_select_btn' id='dropdown-box' tabIndex={(open ? '-1' : '0')} role='button' aria-expanded={`${open ? 'true' : 'false'}`} aria-label={`자막 번역 언어선택, 현재 선택된 언어는 ${toLanguageText(language)}입니다.`} onClick={handleClickOpen.bind(this)}>
              <span className='tl_select_text'>{toLanguageText(language)}</span>
              <i className='select_icon_arrow'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='10'
                  height='6'
                  viewBox='0 0 10 6'
                >
                  <path
                    d='M11.189,13.055l3.781,3.971a.688.688,0,0,0,1.009,0,.783.783,0,0,0,0-1.062l-4.284-4.5a.689.689,0,0,0-.985-.022L6.4,15.961a.781.781,0,0,0,0,1.062.688.688,0,0,0,1.009,0Z'
                    transform='translate(-6.188 -11.246)'
                  />
                </svg>
              </i>
            </button>
            <div className='tl_select_inner' role='listbox' aria-labelledby='dropdown-box'>
              <ul ref={ref} className='tl_list'>
                <li className='tll_inner'>
                  <a href='#' className='tll_link' tabIndex={(open ? '0' : '-1')} onClick={handleClickLanguageItem.bind(this, TRANSLATE.CODE_KOR)}>{TRANSLATE.TEXT_KOR}</a>
                </li>
                <li className='tll_inner'>
                  <a href='#' className='tll_link' tabIndex={(open ? '0' : '-1')} onClick={handleClickLanguageItem.bind(this, TRANSLATE.CODE_ENG)}>{TRANSLATE.TEXT_ENG}</a>
                </li>
                <li className='tll_inner'>
                  <a href='#' className='tll_link' tabIndex={(open ? '0' : '-1')} onClick={handleClickLanguageItem.bind(this, TRANSLATE.CODE_JP)}>{TRANSLATE.TEXT_JP}</a>
                </li>
                <li className='tll_inner'>
                  <a href='#' className='tll_link' tabIndex={(open ? '0' : '-1')} onClick={handleClickLanguageItem.bind(this, TRANSLATE.CODE_CN)}>{TRANSLATE.TEXT_CN}</a>
                </li>
                <li className='tll_inner'>
                  <a href='#' className='tll_link' tabIndex={(open ? '0' : '-1')} onClick={handleClickLanguageItem.bind(this, TRANSLATE.CODE_ESP)}>{TRANSLATE.TEXT_ESP}</a>
                </li>
                <li className='tll_inner'>
                  <a href='#' className='tll_link' tabIndex={(open ? '0' : '-1')} onClick={handleClickLanguageItem.bind(this, TRANSLATE.CODE_PT)}>{TRANSLATE.TEXT_PT}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='translate_setting_w'>
          <div className='translate_setting_fontsize'>
            <span className='icon_translate_fontsize'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='14'
                viewBox='0 0 20 14'
              >
                <g transform='translate(-693.395 -506.596)'>
                  <path d='M713.3,506.6H701.31l-.107,4.538h1.179l.1-1.3a2.239,2.239,0,0,1,.63-1.572,2.645,2.645,0,0,1,1.736-.464,1.65,1.65,0,0,1,1.185.329,1.884,1.884,0,0,1,.319,1.29v8.32a1.954,1.954,0,0,1-.311,1.291,1.454,1.454,0,0,1-1.1.336h-.987v1.2h6.688v-1.2h-.851a1.756,1.756,0,0,1-1.233-.319,1.932,1.932,0,0,1-.315-1.308l.025-8.285a1.989,1.989,0,0,1,.311-1.331,1.641,1.641,0,0,1,1.179-.321,2.644,2.644,0,0,1,1.736.464,2.235,2.235,0,0,1,.63,1.572l.1,1.3H713.4Z' />
                  <path d='M693.466,512.121l-.071,3.1h1.155l.073-.991a1.028,1.028,0,0,1,.253-.691,1.324,1.324,0,0,1,.876-.222.692.692,0,0,1,.469.115.87.87,0,0,1,.116.56v4.774a.861.861,0,0,1-.118.539.583.583,0,0,1-.439.113h-.813V520.6h4.314v-1.183l-.761,0a.776.776,0,0,1-.494-.114.89.89,0,0,1-.114-.566l.012-4.759a.885.885,0,0,1,.116-.554.772.772,0,0,1,.51-.11,1.292,1.292,0,0,1,.791.191,1.032,1.032,0,0,1,.289.742l.074.971h1.15l-.068-3.1Z' />
                </g>
              </svg>
            </span>
            <span className='text_translate_fontsize'>글자크기</span>
            <div className='translate_controller_w'>
              <button
                className='btn_controller_fontsize_down' aria-label='번역 폰트 작게' disabled={(size <= SIZE.LIVE_TRANSLATE_SETTING_LIMIT_SIZE_DOWN)}
                onClick={handleClickTextSize.bind(this, SIZE.LIVE_TRANSLATE_SETTING_CONTROL_SIZE * -1)}
              >
                <span className='icon_controller_down'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='27'
                    height='26'
                    viewBox='0 0 27 26'
                  >
                    <g transform='translate(3 -2)'>
                      <rect
                        width='27'
                        height='26'
                        transform='translate(-3 2)'
                      />
                      <path d='M12,18H24' transform='translate(-7.5 -3)' />
                    </g>
                  </svg>
                  <i className='hide'>폰트 작게</i>
                </span>
              </button>
              <button
                className='btn_controller_fontsize_up' aria-label='번역 폰트 크게' disabled={size >= SIZE.LIVE_TRANSLATE_SETTING_LIMIT_SIZE_UP}
                onClick={handleClickTextSize.bind(this, SIZE.LIVE_TRANSLATE_SETTING_CONTROL_SIZE)}
              >
                <span className='icon_controller_up'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='26'
                    height='26'
                    viewBox='0 0 26 26'
                  >
                    <defs>
                      {/* <style>.a{fill:#222;}.b{fill:none;stroke:#828282;stroke-linecap:round;stroke-linejoin:round;}</style> */}
                    </defs>
                    <g transform='translate(31 -2)'>
                      <rect
                        width='26'
                        height='26'
                        transform='translate(-31 2)'
                      />
                      <path
                        className='b'
                        d='M18,12V24'
                        transform='translate(-36 -3)'
                      />
                      <path
                        className='b'
                        d='M12,18H24'
                        transform='translate(-36 -3)'
                      />
                    </g>
                  </svg>
                  <i className='hide'>폰트 크게</i>
                </span>
              </button>
            </div>
          </div>
          <div className='translate_setting_sync'>
            <span className='icon_translate_sync'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='23'
                height='16'
                viewBox='0 0 23 16'
              >
                <g transform='translate(-722.734 -505.5)'>
                  <path d='M722.734,508.8a.712.712,0,0,0,.735.686h8.879a.688.688,0,1,0,0-1.372h-8.879A.712.712,0,0,0,722.734,508.8Z' />
                  <path d='M722.734,513.5a.712.712,0,0,0,.735.686h5.387a.688.688,0,1,0,0-1.372h-5.387A.712.712,0,0,0,722.734,513.5Z' />
                  <path d='M722.734,518.2a.711.711,0,0,0,.735.685h8.879a.687.687,0,1,0,0-1.371h-8.879A.712.712,0,0,0,722.734,518.2Z' />
                  <path d='M734.825,517.336a.771.771,0,0,0,1.035.07.654.654,0,0,0,.076-.967,4.233,4.233,0,0,1-1.145-3.234,4.325,4.325,0,0,1,1.638-3.043,4.849,4.849,0,0,1,1.579-.834v1.6a.23.23,0,0,0,.141.208.265.265,0,0,0,.1.021.256.256,0,0,0,.157-.053l3.338-2.6a.22.22,0,0,0,.088-.175.224.224,0,0,0-.088-.176l-3.338-2.6a.26.26,0,0,0-.261-.032.229.229,0,0,0-.141.207v2.181a6.4,6.4,0,0,0-2.539,1.215,5.665,5.665,0,0,0-2.143,3.98A5.541,5.541,0,0,0,734.825,517.336Z' />
                  <path d='M737.21,518.673a.224.224,0,0,0,.088.176l3.339,2.6a.254.254,0,0,0,.156.053.274.274,0,0,0,.1-.021.228.228,0,0,0,.14-.207V519.09a6.4,6.4,0,0,0,2.539-1.215,5.566,5.566,0,0,0,.645-8.212.77.77,0,0,0-1.035-.071.656.656,0,0,0-.076.968,4.235,4.235,0,0,1,1.145,3.234,4.328,4.328,0,0,1-1.639,3.044,4.847,4.847,0,0,1-1.579.833v-1.6a.227.227,0,0,0-.14-.207.26.26,0,0,0-.261.031l-3.339,2.6A.224.224,0,0,0,737.21,518.673Z' />
                </g>
              </svg>
            </span>
            <span className='text_translate_sync'>자막싱크</span>
            <span className='num_translate_sync'>{(sync + 5).toFixed(1)}</span>
            <div className='translate_controller_w'>
              <button
                className='btn_controller_fontsize_down' aria-label={`번역 싱크 빠르게, 현재 속도 ${sync}`} disabled={sync <= SIZE.LIVE_TRANSLATE_SETTING_LIMIT_SYNC_DOWN}
                onClick={handleClickSync.bind(this, SIZE.LIVE_TRANSLATE_SETTING_CONTROL_SYNC * -1)}
              >
                <span className='icon_controller_down'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='27'
                    height='26'
                    viewBox='0 0 27 26'
                  >
                    <g transform='translate(3 -2)'>
                      <rect
                        width='27'
                        height='26'
                        transform='translate(-3 2)'
                      />
                      <path d='M12,18H24' transform='translate(-7.5 -3)' />
                    </g>
                  </svg>
                  <i className='hide'>폰트 작게</i>
                </span>
              </button>
              <button
                className='btn_controller_fontsize_up' aria-label={`번역 싱크 느리게, 현재 속도 ${sync}`} disabled={sync >= SIZE.LIVE_TRANSLATE_SETTING_LIMIT_SYNC_UP}
                onClick={handleClickSync.bind(this, SIZE.LIVE_TRANSLATE_SETTING_CONTROL_SYNC)}
              >
                <span className='icon_controller_up'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='26'
                    height='26'
                    viewBox='0 0 26 26'
                  >
                    <defs>
                      {/* <style>.a{fill:#222;}.b{fill:none;stroke:#828282;stroke-linecap:round;stroke-linejoin:round;}</style> */}
                    </defs>
                    <g transform='translate(31 -2)'>
                      <rect
                        width='26'
                        height='26'
                        transform='translate(-31 2)'
                      />
                      <path
                        className='b'
                        d='M18,12V24'
                        transform='translate(-36 -3)'
                      />
                      <path d='M12,18H24' transform='translate(-36 -3)' />
                    </g>
                  </svg>
                  <i className='hide'>폰트 크게</i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
